<script>
import Loader from "@/components/widgets/loader";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import addedit from "./addedit";
import tlptalep from "@/models/tlptalep";
import treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";
import tableheader from "../tableheader/index";
export default {
  mixins: [Api, Sabit, tlptalep],
  page: {
    title: "Birim Talepleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    addedit, treeselect, tableheader
  },
  data() {
    return {
      title: "Birim Talepleri",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Birim Talepleri",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: 1,
        PageSize: 10,
        PageDataSize: 1,
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      loading: true,
      APPLICATION_TYPE: JSON.parse(localStorage.getItem('config')).APPLICATION_TYPE,
      Filter: {
        OrderBy: "Desc=Takipno",
        Atananbirimid: null,
        Durumid: null,
        Oncelikid: null,
        Atananpersonelid: null,
        Personelatanma: false,
        Olusturmatarihi: null,
        Guncellemetarih: null,
        Takipno: null,
        Uygulamaid: null,
        Ucretli: null,
        Baslik: null,
        Aciklama: null
      },
      Birimler: [],
      AtananpersonelComboDataArray: []
    };
  },
  watch: {
    "Birimler": {
      handler(newValue) {
        if (newValue.length > 0) {
          this.Filter.Atananbirimid = newValue[0].id;
          this.Get()
        }
      },
      deep: true,
    },
  },


  methods: {
    Get() {
      var Filter = "&Yeniolusturulduharic=true&" + this.Filter.OrderBy

      if (this.Filter.Baslik != null && this.Filter.Baslik != "" &&
        typeof this.Filter.Baslik === "string" && this.Filter.Baslik.length > 2) {
        Filter += "&Baslik=" + this.Filter.Baslik
      }
      if (this.Filter.Aciklama != null && this.Filter.Aciklama != "" &&
        typeof this.Filter.Aciklama === "string" && this.Filter.Aciklama.length > 2) {
        Filter += "&Aciklama=" + this.Filter.Aciklama
      }

      if (this.Filter.Ucretli != null && this.Filter.Ucretli != "") {
        Filter += "&Ucretli=" + this.Filter.Ucretli
      }
      if (this.Filter.Uygulamaid != null && this.Filter.Uygulamaid != "") {
        Filter += "&Uygulamaid=" + this.Filter.Uygulamaid
      }
      if (this.Filter.Takipno != null && this.Filter.Takipno != "") {
        Filter += "&Takipno=" + this.Filter.Takipno
      }

      if (this.Filter.Atananbirimid != null && this.Filter.Atananbirimid != "") {
        Filter += "&Atananbirimid=" + this.Filter.Atananbirimid
      }
      if (this.Filter.Durumid != null && this.Filter.Durumid != "") {
        Filter += "&Durumid=" + this.Filter.Durumid
      }
      if (this.Filter.Oncelikid != null && this.Filter.Oncelikid != "") {
        Filter += "&Oncelikid=" + this.Filter.Oncelikid
      }
      if (this.Filter.Atananpersonelid != null && this.Filter.Atananpersonelid != "") {
        Filter += "&Atananpersonelid=" + this.Filter.Atananpersonelid
      }
      if (this.Filter.Olusturmatarihi != null && this.Filter.Olusturmatarihi != "") {
        Filter += "&Olusturmatarihi=" + this.Filter.Olusturmatarihi
      }
      if (this.Filter.Guncellemetarih != null && this.Filter.Guncellemetarih != "") {
        Filter += "&Guncellemetarih=" + this.Filter.Guncellemetarih
      }

      Filter += "&Personelatanma=" + this.Filter.Personelatanma


      if (this.Filter.Atananbirimid != null && this.Filter.Atananbirimid != "") {
        this.ActionsFilterGet({
          Service: "tlptalep",
          Page: this.Page,
          Filter: Filter,
        }).then((res) => {
          this.TableData = res.Data;
          this.Page.PageDataSize = res.TotalCount;
          this.loading = false;
        });
      }
      else {
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      }
    },
    goToDetailPage(Id) {
      const routeData = this.$router.resolve({ name: 'talepdetail', params: { Talepid: Id }, });
      window.open(routeData.href, '_blank');
    },

    Guncelle(Data) {
      Data.Lastmodifiedby = this.TokenUserId
      Data.Atananbirimid = null
      Data.Durumid = this.FormDataType.Durumid.ComboDataArray.find(item => item.Kod === '3').id;
      this.Update("tlptalep", Data)
    },
    GuncellePersonel(Data) {
      Data.Durumid = this.FormDataType.Durumid.ComboDataArray.find(item => item.Kod === '10').id;
      Data.Harcananzaman = Data.Isgucu
      Data.Lastmodifiedby = this.TokenUserId
      this.Update("tlptalep", Data)
    }

  },
  created() {
    this.ActionsFilterGet({ Service: "obirim", FullData: true, Filter: "&Userid=" + this.TokenUserId }).then((res) => {
      this.Birimler = res.Data.map(item => ({
        id: item.Id,
        label: item.Birimadi
      }));
    });


    this.ActionsFilterGet({ Service: "opersonel", FullData: true, Filter: "&YetkilibirimUserid="+  this.TokenUserId  }).then((res) => {
      this.AtananpersonelComboDataArray = res.Data.map(item => ({
        id: item.Id,
        label: item.Adsoyad
      }));
    });
  }
};
</script>

<template>
  <Loader :loading="loading">
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4">
                </div>
                <div class="col-sm-8">
                  <div class="text-sm-end"></div>
                </div>
              </div>
              <div class="accordion mb-3">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseOne">
                      Filtreleme
                    </button>
                  </h2>
                  <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show"
                    aria-labelledby="panelsStayOpen-headingOne">
                    <div class="accordion-body">

                      <div class="row">

                        <b-form-group class="col-lg-3" label="Takip Numarası">
                          <b-form-input v-model="Filter.Takipno" type="number"></b-form-input>
                        </b-form-group>

                        <b-form-group class="col-lg-3" label="Başlık">
                          <b-form-input v-model="Filter.Baslik" type="text"></b-form-input>
                        </b-form-group>
                        <b-form-group class="col-lg-3" label="Açıklama">
                          <b-form-input v-model="Filter.Aciklama" type="text"></b-form-input>
                        </b-form-group>
                        <b-form-group class="col-lg-3" label-for="text" :label="FormDataType.Atananbirimid.FieldTitle"
                          :key="Filter.Atananbirimid">
                          <treeselect :multiple="false" :options="Birimler" placeholder="Seçiniz..."
                            v-model="Filter.Atananbirimid" />
                          <treeselect-value :value="Filter.Atananbirimid" />
                        </b-form-group>

                        <b-form-group class="col-lg-3" label-for="text" :label="FormDataType.Durumid.FieldTitle"
                          :key="Filter.Durumid">
                          <treeselect :multiple="false" :options="FormDataType.Durumid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Durumid" />
                          <treeselect-value :value="Filter.Durumid" />
                        </b-form-group>

                        <b-form-group class="col-lg-3" label-for="text" :label="FormDataType.Oncelikid.FieldTitle"
                          :key="Filter.Oncelikid">
                          <treeselect :multiple="false" :options="FormDataType.Oncelikid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Oncelikid" />
                          <treeselect-value :value="Filter.Oncelikid" />
                        </b-form-group>

                        <b-form-group class="col-lg-3" label-for="text"
                          :label="FormDataType.Atananpersonelid.FieldTitle" :key="Filter.Atananpersonelid">
                          <treeselect :multiple="false" :options="FormDataType.Atananpersonelid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Atananpersonelid" />
                          <treeselect-value :value="Filter.Atananpersonelid" />
                        </b-form-group>


                        <b-form-group class="col-lg-3" label-for="text" v-if="APPLICATION_TYPE == 1"
                          :label="FormDataType.Uygulamaid.FieldTitle" :key="Filter.Uygulamaid">
                          <treeselect :multiple="false" :options="FormDataType.Uygulamaid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Uygulamaid" />
                          <treeselect-value :value="Filter.Uygulamaid" />
                        </b-form-group>
                        <b-form-group class="col-lg-3" label="Oluşturma Tarihi">
                          <b-form-input v-model="Filter.Olusturmatarihi" type="date"></b-form-input>
                        </b-form-group>

                        <b-form-group class="col-lg-3" label="Güncelleme Tarihi">
                          <b-form-input v-model="Filter.Guncellemetarih" type="date"></b-form-input>
                        </b-form-group>

                        <b-form-group class="col-lg-1" v-if="APPLICATION_TYPE == 1" label="Ücretli">
                          <b-form-checkbox value="true" v-model="Filter.Ucretli" plain></b-form-checkbox>
                        </b-form-group>
                        <b-form-group class="col-lg-1" label="Personele Atanma">
                          <b-form-checkbox value="true" v-model="Filter.Personelatanma" plain></b-form-checkbox>
                        </b-form-group>


                        <div class="col-lg-4">
                          <button class="btn btn-success mt-2" data-bs-dismiss="offcanvas" type="button"
                            data-bs-target="#demo" @click="Get()">
                            Filtreleme
                          </button>
                        </div>

                      </div>


                    </div>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <tableheader @OrderBy="Filter.OrderBy = $event, Get()" :Data='APPLICATION_TYPE == 1 ? [
                        { "Takipno": "Takip No" },
                        { "Baslik": "Başlık" },
                        { "Uygulama": "Uygulama" },
                        { "Olusturan": "Talep Sahibi" },
                        { "Taleptip": "Talep Tipi" },
                        { "Durum": "Durum" },
                        { "Oncelik": "Öncelik" },
                        { "Destekoncelik": "Destek Öncelik" },
                        { "Tahminibitis": "Tahmini Bitiş Tarihi" },
                        { "Isgucu": "İş Gücü" },
                        { "": "Atanan Personel & İşlem" },
                      ] : [
                        { "Takipno": "Takip No" },
                        { "Baslik": "Başlık" },
                        { "Olusturan": "Talep Sahibi" },
                        { "Taleptip": "Talep Tipi" },
                        { "Durum": "Durum" },
                        { "Oncelik": "Öncelik" },
                        { "Destekoncelik": "Destek Öncelik" },
                        { "Tahminibitis": "Tahmini Bitiş Tarihi" },
                        { "Isgucu": "İş Gücü" },
                        { "": "Atanan Personel & İşlem" },
                      ]' />

                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.Takipno }}</th>
                      <td>{{ Data.Baslik }}</td>
                      <td v-if="APPLICATION_TYPE == 1">{{ Data.Uygulama }}</td>
                      <td>{{ Data.Olusturan }}</td>
                      <td>{{ Data.Taleptip }}</td>
                      <td :class="DurumRenklendirme(Data.Durum)">{{ Data.Durum }}</td>
                      <td :class="OncelikRenklendirme(Data.Oncelik)">{{ Data.Oncelik }}</td>
                      <td :class="OncelikRenklendirme(Data.Destekoncelik)">{{ Data.Destekoncelik }}</td>
                      <td>
                        <b-form-input v-model="Data.Tahminibitis" type="date"></b-form-input>
                      </td>
                      <td style="width: 10%;">
                        <b-form-input v-model="Data.Isgucu" type="number"></b-form-input>
                      </td>
                      <td style="width: 20%;">

                        <div class="container">
                          <div class="row align-items-center">
                            <div class="col">
                              <treeselect v-if="APPLICATION_TYPE == 1" :multiple="false" :options="FormDataType.Atananpersonelid.ComboDataArray"
                                placeholder="Seçiniz..." v-model="Data.Atananpersonelid" />

                              <treeselect v-else :multiple="false" :options="AtananpersonelComboDataArray"
                                placeholder="Seçiniz..." v-model="Data.Atananpersonelid"  />


                            </div>
                            <div class="col-auto">
                              <b-button-group>

                                <b-button v-b-tooltip.hover title="Kaydet" variant="success"
                                  @click="GuncellePersonel(Data)"> <i class="fa fa-share"></i> </b-button>
                                <b-button v-if="!Data.Atananpersonelid" v-b-tooltip.hover title="İade Et"
                                  variant="warning" @click="Guncelle(Data)"> <i class="fa fa-share"></i> </b-button>

                                <b-button v-b-tooltip.hover title="Detay" variant="info"
                                  @click="goToDetailPage(Data.Id)"><i class="far fa-eye"></i></b-button>
                              </b-button-group>

                            </div>
                          </div>
                        </div>


                      </td>
                    </tr>
                  </tbody>
                </table>
                <br /><b>Toplam Kayıt Sayısı: {{ Page.PageDataSize }}</b>
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
                  :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"
                  :limit="Math.min(5, Math.ceil(Page.PageDataSize / Page.PageSize))"
                  @page-click="ChangePage($event, (Page.PageDataSize / Page.PageSize))">
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <addedit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get" />
    </Layout>
  </Loader>
</template>
